import ApiError from '~/types/ApiError';

import { parseExtranetReplayFailure } from './parseReplayFailure';
import type { ExtranetReplayFailure } from './types';

export function isReplayApprovalFailure(err: unknown): boolean {
  return err instanceof ApiError && parseExtranetReplayFailure(err.responseBody) !== null;
}

export function getApprovalFailureSnackbarVariant(err: unknown): 'error' | 'warning' {
  if (err instanceof ApiError && err.status === 409 && !isReplayApprovalFailure(err)) {
    return 'warning';
  }

  return 'error';
}

export function getApprovalFailureMessage(err: unknown, actionType: 'approve' | 'reject'): string {
  if (err instanceof ApiError) {
    if (actionType === 'approve') {
      const replayFailure = parseExtranetReplayFailure(err.responseBody);
      if (replayFailure) {
        return `Failed to approve: ${replayFailure.agentMessage}`;
      }
    }

    if (err.status === 409) {
      return `Already processed: ${err.message.replace(/^Network error received \(status code \d+\): /, '')}`;
    }
  }

  if (err instanceof Error) {
    return `Failed to ${actionType}: ${err.message}`;
  }

  return `Failed to ${actionType}`;
}

export function getBulkApproveFailureSummary(failures: Array<ExtranetReplayFailure>): string | undefined {
  if (failures.length === 0) {
    return undefined;
  }

  if (failures.length === 1) {
    return failures[0].agentMessage;
  }

  return `${failures.length} changes could not be approved and remain pending. ${failures[0].agentMessage}`;
}
